<template>
  <div>
    <Mian
      ref="main"
      :loading="loading"
      :tableData="tableData"
      :disabled="disabled"
      @reload="getData"
      @openUploadFormDialog="() => (uploadFromDialogVisible = true)"
      @openChooseTechDialog="() => (chooseTechDialogVisible = true)"
      @openEditFromDialog="openEditFromDialog"
    >
    </Mian>

    <UploadFromDialog
      :title="'上传订单验货文档'"
      :visible.sync="uploadFromDialogVisible"
      :orderCode="orderCode"
      @reload="getData"
    />
    <ChooseTechDocDialog
      :title="'从工艺文档选择'"
      :visible.sync="chooseTechDialogVisible"
      :orderCode="orderCode"
      @reload="getData"
    />

    <EditFromDialog
      :title="'编辑订单验货文档'"
      :visible.sync="editFromDialogOpeion.visible"
      :orderInspectionDocCode="editFromDialogOpeion.code"
      :orderCode="orderCode"
      @reload="getData"
    />
  </div>
</template>
<script>
import UploadFromDialog from './components/upload-form/dialog.vue'
import ChooseTechDocDialog from './components/tech-doc/dialog.vue'
import EditFromDialog from './components/edit-form/dialog.vue'
import Mian from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Mian, UploadFromDialog, EditFromDialog, ChooseTechDocDialog },
  props: {
    orderCode: String,
    disabled: { type: Boolean, default: false },
  },
  data() {
    return {
      tableData: [],
      loading: false,
      uploadFromDialogVisible: false,
      chooseTechDialogVisible: false,
      editFromDialogOpeion: {
        visible: false,
        code: '',
      },
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      if (!this.orderCode) return
      this.loading = true
      this.tableData = []
      this.$api
        .orderInspectionDocListApi({
          orderCode: this.orderCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
    openEditFromDialog(code) {
      this.editFromDialogOpeion = {
        visible: true,
        code,
      }
    },
  },
}
</script>
